var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4798 19.171V13.915H35V19.171H21.4798Z",
    fill: "#0E0D09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7439 35.5227V30.2667H34.9999V35.5227H29.7439Z",
    fill: "#0E0D09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7439 27.3557V22.0997H34.9999V27.3557H29.7439Z",
    fill: "#0E0D09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 27.3557V22.0997H18.256V27.3557H13Z",
    fill: "#0E0D09"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 35.5235V30.2675H26.5202V35.5235H13Z",
    fill: "#0E0D09"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.1713V13.9153H18.256V19.1713H13Z",
    fill: "#0E0D09"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1065 24.727C27.1065 26.422 25.7324 27.796 24.0374 27.796C22.3424 27.796 20.9683 26.422 20.9683 24.727C20.9683 23.032 22.3424 21.6579 24.0374 21.6579C25.7324 21.6579 27.1065 23.032 27.1065 24.727Z",
    fill: "#F6A62D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentra);
export default __webpack_public_path__ + "static/media/Sentra.7956405cd05ce13ada253b43f07582f3.svg";
export { ForwardRef as ReactComponent };